
<tr @click="processClick" :class="{ 'cursor-pointer': action }">
  <td class="item-category">
    <div class="d-flex align-items-center font-weight-bold">
      <i class="far fa-fw p-1 mr-2" :class="item.categoryIcon"></i>
      {{ item.categoryName }}
    </div>
    <div>
      <i class="far fa-fw mr-2"></i>
      {{ item.typeName }}
    </div>
  </td>
  <td>
    <div class="badge badge-pill badge-info sh-prop-s" v-if="displayRelevantBadge">Relevant</div>
    <div class="font-weight-bold">{{ item.title }}</div>

    <div v-simplify-html="item.description" />
  </td>
  <td class="item-labels">
    <div class="mt-2 container">
      <div class="row">
        <div v-for="label in item.labels" :key="label.id" @click.prevent.stop="selectLabel(label)">
          <div class="mr-2 mb-2 item-label" :style="{ 'background-color': label.color }">
            <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
            {{ label.title }}
          </div>
        </div>
      </div>
    </div>
  </td>
  <td class="item-icons">
    <div class="mt-2 text-secondary" v-if="item.attachmentCount > 0">
      <i class="far fa-file"></i>
      {{ item.attachmentCount }}
    </div>
  </td>
  <td class="item-icons">
    <div class="mt-2 text-secondary" v-if="item.commentCount > 0">
      <i class="far fa-comment"></i>
      {{ item.commentCount }}
    </div>
  </td>

  <td class="item-icons">
    <div class="mt-2 text-secondary" v-if="item.subtaskTotal > 0">
      <i class="fas fa-tasks"></i>
      {{ item.subtaskDone }} of {{ item.subtaskTotal }}
    </div>
  </td>

  <td class="font-weight-bold item-date">
    <div>Created: {{ item.createdDate | formatDateTime }}</div>
    <div v-if="item.archivedDate">Archived: {{ item.archivedDate | formatDateTime }}</div>
    <div v-else>Archived: -</div>
  </td>
  <td class="align-middle item-status">
    <BoardItemStatus
      :status="getBoardItemStatus(item)"
      :styles="{
        'font-size': '0.9em',
        width: '100px',
      }"
    />
  </td>
</tr>
